import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FnRatingComponent } from './fn-rating.component';

export * from './fn-rating.component';
export * from './fn-rating.model';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [FnRatingComponent],
    exports: [FnRatingComponent]
})
export class FnRattingModule {

}
